import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const ListGroupIndiApi = createAsyncThunk('group/list', async ({ id }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/group/list/${id}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const ListGroupIndividual = createSlice(
  {
    name: 'ListGroupIndivi',
    initialState,
    reducers: {},
    extraReducers: {
      [ListGroupIndiApi.pending]: (state) => {
        state.isLoading = true;
      },
      [ListGroupIndiApi.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      },
      [ListGroupIndiApi.rejected]: (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      },
    },
  },
);

export default ListGroupIndividual;
